import { c as _c } from "react-compiler-runtime";
import { useEffect } from 'react';
import { useCellSelectionSelector } from '../../redux/reduxHooks';
import { getDidDragMove, getIsDragging } from '../redux/cellSelectionSlice';
import { CELL_DRAG_ACTIVE_ATTRIBUTE } from '../../table/constants/cellSelectionAttributes';
/**
 * Suppresses native text selection for the remainder of a cell-range drag,
 * Google-Sheets style.
 *
 * A plain mousedown on a cell intentionally does not preventDefault, so the
 * browser is free to start a native text selection and the user can drag to
 * highlight text *within* a single cell. Once the drag leaves the cell it
 * started in, the gesture is unambiguously a cell-range selection: the reducer
 * flips `didDragMove` on the first `dragOver` that moves the focus, and this
 * hook then drops whatever text got highlighted and blocks any further text
 * selection until the drag ends.
 *
 * Fill-handle drags already preventDefault on mousedown, so no text selection
 * ever starts there; this hook is harmless for them.
 */
export const useSuppressTextSelectionWhileCellDrag = t0 => {
  const $ = _c(4);
  const {
    scrollContainerRef
  } = t0;
  const isDragging = useCellSelectionSelector(getIsDragging);
  const didDragMove = useCellSelectionSelector(getDidDragMove);
  const isSuppressed = isDragging && didDragMove;
  let t1;
  let t2;
  if ($[0] !== isSuppressed || $[1] !== scrollContainerRef) {
    t1 = () => {
      var _scrollContainerRef$c, _scrollContainerRef$c2, _window$getSelection;
      if (!isSuppressed) {
        return;
      }
      const table = (_scrollContainerRef$c = (_scrollContainerRef$c2 = scrollContainerRef.current) === null || _scrollContainerRef$c2 === void 0 ? void 0 : _scrollContainerRef$c2.querySelector("table")) !== null && _scrollContainerRef$c !== void 0 ? _scrollContainerRef$c : null;
      (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 || _window$getSelection.removeAllRanges();
      table === null || table === void 0 || table.setAttribute(CELL_DRAG_ACTIVE_ATTRIBUTE, "true");
      const preventSelectStart = _temp;
      document.addEventListener("selectstart", preventSelectStart);
      return () => {
        document.removeEventListener("selectstart", preventSelectStart);
        table === null || table === void 0 || table.removeAttribute(CELL_DRAG_ACTIVE_ATTRIBUTE);
      };
    };
    t2 = [isSuppressed, scrollContainerRef];
    $[0] = isSuppressed;
    $[1] = scrollContainerRef;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
};
function _temp(e) {
  return e.preventDefault();
}